import type { SVGProps } from 'react';
const SvgEuroCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Euro Circle Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M11.893 12.95a3.4 3.4 0 0 1-1.321.264A3.806 3.806 0 0 1 6.938 9.25a3.806 3.806 0 0 1 3.634-3.964c.367.002.733.06 1.083.172M5.286 7.929H9.25M5.286 10.571H9.25" />
      <path d="M9.25 17.84a8.59 8.59 0 1 0 0-17.18 8.59 8.59 0 0 0 0 17.18" />
    </g>
  </svg>
);
export default SvgEuroCircle;
